import Hero from "../components/Hero";
import Accordion from "../designSystem/Accordion";
import FilledButton from "../designSystem/FilledButton";
import OutlinedButton from "../designSystem/OutlinedButton";
import HeroImage from "../../assets/images/Home1.jpg";
import FeatureCards from "../designSystem/FeatureCards";
import ContactUs from "../components/ContactUs";
import NewsletterSubscription from "../components/HomePage/NewsletterSubscription";
import AboutUs from "../components/HomePage/AboutUs";
import OutlinedLightButton from "../designSystem/OutlinedLightButton";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <Hero
        title="Award winning independent mortgage advice"
        subtitle="Unrivalled customer service"
        titleAlign="left"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="left"
        children={
          <div className="buttons-container-hero">
            <FilledButton
              text="About Us"
              onClick={() => navigate("/our-team")}
            />
            <OutlinedLightButton
              text="Contact Us"
              onClick={() => navigate("/#contact-us-section")}
            />
          </div>
        }
      />
      <FeatureCards />
      <NewsletterSubscription />
      <AboutUs />
      <div className="burgandy-container">
        <div className="column">
          <div className="content">
            Not only do you need to consider which mortgage is most suitable for
            you, you also need to think about which interest rate options are
            most likely to suit your needs.
          </div>
          <div className="divider" />
          <h2>WPP Financial Services can help</h2>
          <div className="sizedBox" />
          <OutlinedLightButton
            text="Contact Us"
            onClick={() => {
              navigate("/#contact-us-section");
            }}
            className="contact-button"
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
